import { Suspense } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ErrorBoundary } from 'react-error-boundary'

import { ErrorFallback, LoadingBackdrop } from 'presentation/components/elements'
import Layout from 'presentation/components/layout'
import { authUser } from 'presentation/redux/slices/authUserSlice'
import PrivateRoutes from './privateRoutes'
import PublicPages from './publicPages/publicPages'
import PrivatePages from './privatePages/privatePages'
import { urlRoutes } from './config/urlRoutes/urlRoutes'

export default function Index() {
  const { logged } = useSelector(authUser)
  return (
    <Router>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Layout>
          <Suspense fallback={<LoadingBackdrop />}>
            <Routes>
              <Route path={urlRoutes.public.auth.url} element={<PublicPages />} />
              <Route path={urlRoutes.public.footer.url} element={<PublicPages />} />
              <Route element={<PrivateRoutes isLoggedIn={logged} />}>
                <Route path={urlRoutes.private.url} element={<PrivatePages rol="Admin" />} />
              </Route>
            </Routes>
          </Suspense>
        </Layout>
      </ErrorBoundary>
    </Router>
  )
}
